import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { Edit } from '@mui/icons-material'
import {
	Button,
	FormControl,
	IconButton,
	InputLabel,
	MenuItem,
	OutlinedInput,
	Select,
	Stack,
	TextField,
	TextareaAutosize,
} from '@mui/material'
import { useAppServices, useUploadImage } from 'hook/services'
import { useUserInfo } from 'context/user'
import FormField from 'components/FormField'
import MDInput from 'components/MDInput'
import { useParams } from 'react-router-dom'
import Editor from 'components/editor'

const EditCollectionModal = ({ appData, handleRefresh , type, editData}) => {
	const uploadImage = useUploadImage()
	const params = useParams()
	const [openAddProduct, setOpenAddProduct] = useState(false)
	const AppService = useAppServices()
	const [user] = useUserInfo()
	var axios = require('axios')
	const handlemodal = () => {
		setOpenAddProduct(true)
	}

	useEffect(async () => { }, [])

	function AddProduct({ open, onClose }) {
		const [processing, setProcessing] = useState(false)
		const [editor, setEditor] = useState('')
		const [dataCollection, setDataCollection] = useState([])
		const [selectedCollection, setSelectedCollection] = useState([])
		const getApps = async () => {
			const { response } = await AppService.app.get_single_app({
				query: `_id=${params.app_id}`,
			});
			setDataCollection(response?.data?.triggers);
		};

		useEffect(() => {
			getApps();
		}, []);

		const handleSubmit = async (e) => {
			e.preventDefault()
			setProcessing(true)
			const payload = {
				app_id: appData?.app_id,
				name: e.target.name.value,
				type: type,
				id: editData?._id,
				scenerio: e.target.scenerio.value,
				description: e.target.description.value
			}

			const { response } = await AppService.AppCollections.update({payload})

			if (response) {
				setProcessing(false)
				onClose()
				handleRefresh()
			}
		}
		const style = {
			position: 'absolute',
			top: '50%',
			left: '50%',
			transform: 'translate(-50%, -50%)',
			width: 400,
			height: 'auto',
			overflow: 'auto',
			bgcolor: 'background.paper',
			border: '2px  #000',
			boxShadow: 24,
			p: 4,
		}
		return (
			<MDModal
				open={open}
				onClose={onClose}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<MDBox>
					<MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
						<MDTypography variant="h5" mb={2}>
							Edit Collection
						</MDTypography>

						<MDBox>
							<MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
								Name
							</MDTypography>
							<MDInput
								defaultValue={editData?.name} 
								label="Name" 
								name="name" 
								fullWidth 
							/>
						</MDBox>
						<MDBox>
							<MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
								Scenario
							</MDTypography>
							<MDInput
								defaultValue={editData?.scenerio} 
								label="Scenario" 
								name="scenerio" 
								fullWidth 
							/>
						</MDBox>
						<MDBox>
							<MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
								Description
							</MDTypography>
							<MDInput
								defaultValue={editData?.description} 
								label="Description" 
								name="description" 
								fullWidth 
							/>
						</MDBox>

						<MDBox display="flex" justifyContent="flex-end">
							<MDButton
								variant="gradient"
								color="primary"
								type="button"
								sx={{ mt: 4, mb: 1 }}
								onClick={closeAddProduct}
							>
								close
							</MDButton>
							<MDButton
								variant="gradient"
								color="info"
								type="submit"
								sx={{ mt: 4, mb: 1, ml: 1 }}
								loading={processing}
								disabled={processing}
							>
								Add
							</MDButton>
						</MDBox>
					</MDBox>
				</MDBox>
			</MDModal>
		)
	}
	const closeAddProduct = () => {
		// if (subscription?._id)
		setOpenAddProduct(false)
	}
	return (
		<>
			<IconButton color="secondary" onClick={handlemodal}>
				<Edit />
			</IconButton>

			<AddProduct open={openAddProduct} onClose={closeAddProduct} />
		</>
	)
}

export default EditCollectionModal
